// history.scrollRestoration = 'auto';
 let collection_products = [], ppp = parseInt(document.querySelector("#ProductGridContainer")?.dataset.ppp), all_products_grid, infiniScroll_count = 0, triggered = false, filters_inputs = [];
function disable_filters() {
  filters_inputs.forEach((i) => i.setAttribute("disabled", ""));
}
function enable_filters() {
  filters_inputs.forEach((i) => i.removeAttribute("disabled"));
}
function clearInfiniScrollGrid() {
  infiniScroll_grid.querySelectorAll(".grid__item").forEach((item) => {
    item.remove();
  });
}

function updateInfiniScrollGrid() {
  if (infiniScroll_grid) {
    let infiniScroll_items = infiniScroll_grid.querySelectorAll(".grid__item");
    let count = 0;
    while (count < ppp && infiniScroll_items[count]) {
      infiniScroll_items[count].remove();
      count++;
    }
  }
}
(() => {
  const { createApp } = Vue;

  let ConvertStringToHTML = function (str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, "text/html");
    return doc.body;
  };

  let initScrollToTop = () => {
    document.querySelectorAll(".btn-scroll-top").forEach(($btn) => {
      $btn.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    });
  };

  const SESSION_KEY_CACHE = "collection_pages";
  let PAGES_CACHE = JSON.parse(sessionStorage.getItem(SESSION_KEY_CACHE)) || [];

  const SESSION_KEY_SCROLLTOP = "scroll_top";
  let scrollTop = sessionStorage.getItem(SESSION_KEY_SCROLLTOP) || 0;

  let loadCollection = (url) => {
    let timeout = scrollTop == 0 ? 1000 : 0;
    return new Promise((resolve) => {
      // check if not in cache
      let cachedPage = PAGES_CACHE.find((item) => item.url == url);
      if (cachedPage) {
        setTimeout(() => {
          resolve(cachedPage.res);
        }, timeout);
      } else {
        fetch(url)
          .then((res) => res.text())
          .then((res) => {
            // add page to cache
            PAGES_CACHE.push({
              index: vm.next_page_index,
              url: url,
              res: res,
            });
            sessionStorage.setItem(
              SESSION_KEY_CACHE,
              JSON.stringify(PAGES_CACHE)
            );

            resolve(res);
          })
          .catch(console.error);
      }
    });
  };

  let vms_products = [];
  let VueProductCards = () => {
    let $cards = Array.from(
      document.querySelectorAll(".card-wrapper:not(.v-initialized)")
    );
    vms_products = $cards.map(($card) => {
      let $productJsonData = $card.querySelector("[data-product-json]");
      let product = JSON.parse($productJsonData.value);
      // console.log(product);
      let options_with_values = JSON.parse(
        $card.querySelector("[data-product-options-with-values-json]").value
      );
      product.options_with_values = options_with_values;

      // capture scroll top
      $card.querySelectorAll("a").forEach(($a) => {
        $a.addEventListener("click", (e) => {
          sessionStorage.setItem(SESSION_KEY_SCROLLTOP, window.pageYOffset);
        });
      });

      let vm_product;
      if (product) {
        vm_product = createApp({
          delimiters: ["${", "}"],
          data() {
            return { product };
          },
          mounted() {
            this.initImagesSwiper();
            // console.log(product);
            $card.classList.add("v-initialized");
          },
          computed: {},
          methods: {
            initImagesSwiper() {
              let $images = $card.querySelector(".product-images-swiper");
              let initialSlide = window.innerWidth < 768 ? 0 : 1;
              new Swiper($images, {
                touchMove: true,
                speed: 250,
                loop: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: initialSlide,
                slidesPerView: "auto",
                shortSwipes:true,
                touchStartPreventDefault: false,
                threshold:10,
                pagination: {
                  el: $card.querySelector(".swiper-pagination"),
                  clickable: true,
                },
                navigation: {
                  nextEl: $card.querySelector(".swiper-button-next"),
                  prevEl: $card.querySelector(".swiper-button-prev"),
                },
              });
            },
            addItemToCart(e) {
              e.preventDefault();
              let $form = e.currentTarget.closest("form");
              let variant_id = $form.querySelector("input[name=id]").value;

              let variants = [
                {
                  quantity: 1,
                  id: variant_id,
                },
              ];
              if($form.querySelector('input[value="PRE-ORDER"]')){
                variants[0].properties={
                  "":"PRE-ORDER"
                }
              }
              let items = {
                items: variants,
                sections: "cart-drawer",
              };

              fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(items),
              })
                .then((res) => res.json())
                .then((parsedState) => {
                  if (
                    parsedState.sections &&
                    parsedState.sections["cart-drawer"]
                  ) {
                    let $cartDrawer = Shopify.theme.utils.stringToHTML(
                      parsedState.sections["cart-drawer"]
                    );
                    document.querySelector(
                      "#cart-drawer .cart-items"
                    ).innerHTML =
                      $cartDrawer.querySelector(".cart-items").innerHTML;
                    document.dispatchEvent(new CustomEvent("product:added"));
                  } else {
                    document.dispatchEvent(
                      new CustomEvent("cart:update", {
                        detail: { openDrawer: true },
                      })
                    );
                  }
                })
                .catch(console.error);
            },
          },
        }).mount($card.querySelector(".card-quick-add"));
      }

      return vm_product;
    });
  };

  let vm_paginate;
  let ProductsInfiniteLoad = () => {
    /*
    const SELECTORS = {
      paginateWrapper: '.pagination-wrapper'
    };

    let $productsWrap = document.querySelector('.collection-products-wrap');
    // If not collection page, return
    if (!$productsWrap) {
      return;
    }
    

    let $paginateWrapper = document.querySelector(SELECTORS.paginateWrapper);
    // If collection has no pages
    if (!$paginateWrapper) {
      $productsWrap.classList.add('all-pages-loaded');
      return;
    }

    let paginate = JSON.parse($paginateWrapper.dataset.paginate);
    let page_url = $paginateWrapper.dataset.path;

    // add loading gif
    $paginateWrapper.insertAdjacentHTML('afterbegin', '<div v-if="loading" class="loading-wrap"><span class="load-more__icon"></span></div>');

    vm_paginate = createApp({
      delimiters: ['${', '}'],
      data() {
        return { paginate, loading: false, page_url };
      },
      computed: {
        next_page_index() {
          return this.paginate.current_page + 1;
        },
        next_page_url() {
          let vm = this;
          let next_page_url; 
          if (vm.paginate.current_page < vm.paginate.pages) {
            next_page_url = `${page_url}?page=${vm.next_page_index}`;
          }
          return next_page_url;
        },
        allPagesLoaded() {
          return this.paginate.current_page >= this.paginate.pages;
        }
      },
      watch: {
        allPagesLoaded() {
          document.querySelector('.collection-products-wrap')
            .classList[this.allPagesLoaded ? 'add' : 'remove']('all-pages-loaded');
        }
      },
      mounted() {
        this.loadCollectionCache();
        this.observeIntersection();
      },
      methods: {
         
        loadProductCards(res) {
          let vm = this;
          let $res = ConvertStringToHTML(res);
          let $products = $res.querySelectorAll('.product-grid-item');

          // add products
          $products.forEach(($product) => {
            document.querySelector('#product-grid').insertAdjacentElement('beforeend', $product);
          });

          // init vue cards on ajax loaded products
          VueProductCards();

          vm.paginate.current_page += 1;
          vm.loading = false; 
          if (scrollTop) {
            window.scrollTo({
              top: scrollTop
            });
            sessionStorage.removeItem(SESSION_KEY_SCROLLTOP);
          }
        },
        loadCollectionCache() {
          let vm = this;
          let scrollTop = sessionStorage.getItem(SESSION_KEY_SCROLLTOP);
          if (scrollTop) {
            let cachedPages = PAGES_CACHE.filter((item) => item.url.indexOf(vm.page_url) !== -1);
            cachedPages.forEach((page) => { 
              loadCollection(page.url).then(vm.loadProductCards);
            });
          }
        },
        observeIntersection() {
          let vm = this;
           
          let intersectionObserver = new IntersectionObserver(function(entries) {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) return;

            vm.loadMore();
          });

          intersectionObserver.observe($paginateWrapper);
        },
        loadMore() {
          
          let vm = this;
          if (vm.next_page_url) {
            //console.log('LOAD MORE PRODUCTS');
            vm.loading = true;
            
            let url = `${vm.next_page_url}&view=raw`;
            loadCollection(url).then(vm.loadProductCards);
          }
        }
      }
    }).mount($paginateWrapper);
    */
  };

  let CollectionFilters = () => {
    const SELECTORS = {
      filterContainer: ".collection-filters-container",
      filterSection: ".collection-filters",
      productsGrid: "#product-grid",
      paginateWrapper: ".pagination-wrapper",
    };
    (function () {
      let url = `${window.location.pathname}?view=raw-full`;
      fetch(url)
        .then((res) => res.text())
        .then((res) => {
          let parser = new DOMParser();
          let $res = parser.parseFromString(res, "text/html").body;
          all_products_grid = $res.querySelector(SELECTORS.productsGrid);
          infiniScroll_grid = $res
            .querySelector(SELECTORS.productsGrid)
            .cloneNode(true);
          updateInfiniScrollGrid();
        });
    })();
    (function fetch_collection(i) {
      fetch(`${window.location.href}/products.json?page=${i}`)
        .then((res) => res.json())
        .then((res) => {
          if (res.products.length) {
            res.products.forEach((product) =>
              collection_products.push(product)
            );
            fetch_collection(i + 1);
          }
        });
    })(1);
    let $filterSection = document.querySelector(SELECTORS.filterSection);
    if (!$filterSection || !FILTER_SETTINGS) return;
    let page_url = $filterSection.dataset.url;

    let vm_filters = createApp({
      delimiters: ["${", "}"],
      data() {
        return { FILTER_SETTINGS, selected_tags: [], page_url };
      },
      computed: {
        collection_tags() {
          return this.FILTER_SETTINGS.all_tags;
        },

        filters() {
          let filters = this.FILTER_SETTINGS.blocks.map((block) => {
            let filter_tags = block.filter_tags
              .split(", ")
              .filter((tag) => this.collection_tags.indexOf(tag) !== -1);

            return {
              title: block.title,
              filter_tags_handle: block.filter_tags_handle,
              filter_tags: filter_tags,
            };
          });

          return filters;
        },

        url_with_selected_tags() {
          let tags = this.selected_tags;
          let tags_join = tags
            .map((tag) => {
              return tag.replaceAll(/ /g, "-");
            })
            .join("+");
          let url = `${page_url}/${tags_join}`;
          return url;
        },
      },
      watch: {
        selected_tags() {
          this.loadResults();
        },
      },

      methods: {
        updateUrl() {
          window.history.pushState(
            {},
            document.title,
            this.url_with_selected_tags
          );
        },
        loadResults() {
          disable_filters();
          let has_size = false, selected_sizes = [],backToTop = document.querySelector(".back-to-top");
          if (Object.keys(this.selected_tags).length) {
            for (let tag of this.selected_tags) {
              for (let filter of this.filters) {
                if (filter.title == "Size") {
                  if (filter.filter_tags.includes(tag)) {
                    selected_sizes.push(tag);
                    has_size = true;
                  }
                }
              }
            }
            if (has_size) {
              let has_only_size = true;
              for (let tag of this.selected_tags) {
                if (!selected_sizes.includes(tag)) {
                  has_only_size = false;
                  break;
                }
              }
              has_size = !has_only_size;
            }
            let filtered_products = [];
            if (selected_sizes.length && has_size) {
              for (product of collection_products) {
                for (let tag of this.selected_tags) {
                  if (!selected_sizes.includes(tag)) {
                    for (size_tag of selected_sizes)
                      if (
                        product.tags?.includes(tag) &&
                        product.tags?.includes(size_tag)
                      ) {
                        if (!filtered_products.includes(product.id)) {
                          filtered_products.push(product.id);
                          break;
                        }
                      }
                  }
                }
              }
            } else {
              for (product of collection_products) {
                for (let tag of this.selected_tags) {
                  if (product.tags?.includes(tag)) {
                    if (!filtered_products.includes(product.id))
                      filtered_products.push(product.id);
                  }
                }
              }
            }
            for (item of all_products_grid.querySelectorAll(".grid__item")) {
              if (!filtered_products.includes(parseInt(item.dataset.pid))) {
                item.remove();
              }
            }
            let products = all_products_grid.querySelectorAll(".grid__item");
            let $products_grid = document.querySelector(SELECTORS.productsGrid);
            $products_grid.innerHTML = "";
            if (products.length) {
              document.querySelector(".collection--empty").style.display =
                "none";
                if (backToTop)
                backToTop.style.display = "none";
              if (document.querySelector("#more"))
                document.querySelector("#more").style.display = "none";
              if (products.length > ppp) {
                if (document.querySelector("#more"))
                  document.querySelector("#more").style.display = "block";
              }
              for (let i = 0; i < ppp && products[i]; i++) {
                products[i].classList.add('shown');
                $products_grid.insertAdjacentElement("beforeend", products[i]);
              }
              products = all_products_grid.querySelectorAll(".grid__item");
              if(!products.length && backToTop)backToTop.style.display = "block";
              clearInfiniScrollGrid();
              for (let i = 0; i < products.length; i++) {
                products[i].classList.add('shown');
                infiniScroll_grid.insertAdjacentElement(
                  "beforeend",
                  products[i]
                );
              }
              triggered = false;
              VueProductCards();
              (function () {
                let url = `${window.location.pathname}?view=raw-full`;
                fetch(url)
                  .then((res) => res.text())
                  .then((res) => {
                    let parser = new DOMParser();
                    let $res = parser.parseFromString(res, "text/html").body;
                    all_products_grid = $res.querySelector(
                      SELECTORS.productsGrid
                    );
                    enable_filters();
                  });
              })();
            } else {
              (function () {
                let url = `${window.location.pathname}?view=raw-full`;
                fetch(url)
                  .then((res) => res.text())
                  .then((res) => {
                    let parser = new DOMParser();
                    let $res = parser.parseFromString(res, "text/html").body;
                    all_products_grid = $res.querySelector(
                      SELECTORS.productsGrid
                    );
                  });
              })();
              document.querySelector(".collection--empty").style.display =
                "block";
                if (backToTop)
                backToTop.style.display = "none";
              if (document.querySelector("#more"))
                document.querySelector("#more").style.display = "none";
              let $products_grid = document.querySelector(
                SELECTORS.productsGrid
              );
              clearInfiniScrollGrid();
              let products = all_products_grid.querySelectorAll(".grid__item");
              $products_grid.innerHTML = "";
              if (products.length > ppp) {
                if (document.querySelector("#more"))
                  document.querySelector("#more").style.display = "block";
              }
              for (let i = 0; i < ppp && products[i]; i++) {
                products[i].classList.add('shown');
                $products_grid.insertAdjacentElement("beforeend", products[i]);
              }
              products = all_products_grid.querySelectorAll(".grid__item");
              for (let i = 0; i < products.length; i++) {
                products[i].classList.add('shown');
                infiniScroll_grid.insertAdjacentElement(
                  "beforeend",
                  products[i]
                );
              }
              enable_filters();
              VueProductCards();
            }
          } else {
            enable_filters();
            let url = `${window.location.pathname}?view=raw-full`;
            fetch(url)
              .then((res) => res.text())
              .then((res) => {
                let parser = new DOMParser();
                let $res = parser.parseFromString(res, "text/html").body;
                all_products_grid = $res.querySelector(SELECTORS.productsGrid);
              });
              if (backToTop)
              backToTop.style.display = "none";
            if (document.querySelector("#more"))
              document.querySelector("#more").style.display = "none";
            let $products_grid = document.querySelector(SELECTORS.productsGrid);
            clearInfiniScrollGrid();
            let products = cached_complete_product_grid
              ?.cloneNode(true)
              .querySelectorAll(".grid__item");
            $products_grid.innerHTML = "";
            if (products.length) {
              triggered = false;
              if (backToTop)
                backToTop.style.display = "none";
              if (document.querySelector("#more"))
                document.querySelector("#more").style.display = "block";
              document.querySelector(".collection--empty").style.display =
                "none";
              for (let i = 0; i < ppp && products[i]; i++) {
                products[i].classList.add('shown');
                $products_grid.insertAdjacentElement("beforeend", products[i]);
              }
              products = all_products_grid.querySelectorAll(".grid__item");
              for (let i = 0; i < products.length; i++) {
                products[i].classList.add('shown');
                infiniScroll_grid.insertAdjacentElement(
                  "beforeend",
                  products[i]
                );
              }
              VueProductCards();
            } else {
              document.querySelector(".collection--empty").style.display =
                "block";
            }
          }

          // if (vm.url_with_selected_tags) {
          //   let url = `${vm.url_with_selected_tags}?view=raw`;
          //   fetch(url)
          //     .then(res => res.text())
          //     .then((res) => {
          //       let $res = ConvertStringToHTML(res);

          //       // replace products
          //       let $products_grid = document.querySelector(SELECTORS.productsGrid);
          //       $products_grid.innerHTML = $res.querySelector(SELECTORS.productsGrid).innerHTML;

          //       // init vue cards on ajax loaded products
          //       VueProductCards();

          //       // update pagination
          //       console.log($products_grid);
          //       console.log(SELECTORS.paginateWrapper)
          //       let $paginate = document.querySelector(SELECTORS.paginateWrapper);
          //       if ($paginate) {
          //         $paginate.remove();
          //       }
          //       if ($res.querySelector(SELECTORS.paginateWrapper)) {
          //         $products_grid.insertAdjacentElement('afterend', $res.querySelector(SELECTORS.paginateWrapper));
          //         ProductsInfiniteLoad();
          //         //custom code

          //         $paginate = document.querySelector(SELECTORS.paginateWrapper);
          //         let pg_items=$paginate.querySelectorAll('.pagination__item');
          //         for(let i=0; i<pg_items.length; i++){
          //           if(pg_items[i].href){
          //           let new_url = new URL(pg_items[i].href);
          //           console.log(new_url);
          //           new_url.searchParams.delete('view');
          //           if(!document.querySelector('#more a')) document.querySelector('.ajax_paginate').insertAdjacentHTML('afterend',`<div id="more"><a href="${new_url.toString()}"><span class="load-more__icon"></span></a></div>`)
          //           else document.querySelector('#more a').href=new_url.toString();
          //           break;
          //           }
          //         }
          //         let ajax_paginate=document.querySelector('.ajax_paginate');
          //         triggered=false;
          //         document.querySelector('.back-to-top').style.display='none'
          //         console.log(ajax_paginate.querySelectorAll('li'));
          //         ajax_paginate.querySelectorAll('li').forEach(item=>{item.remove()});
          //         let last_page = document.querySelectorAll('.pagination__item:not(.pagination__item-arrow)');
          //         last_page= parseInt(last_page[last_page.length -1].innerText);
          //         console.log(last_page)
          //         let updated_collec_url =new URL(document.querySelector('#more a').href);
          //         for(let j=0; j<last_page; j+=1){
          //           updated_collec_url.searchParams.set('page',`${j+1}`)
          //           ajax_paginate.insertAdjacentHTML('beforeend',`<li ${j===0?'class="active"':''}><a href="${updated_collec_url.toString()}">${j+1}</a></li>`)
          //         }

          //         //end custom code
          //       }else document.querySelector('#more')?.remove();
          //     })
          //     .catch(console.error);
          // }
        },
        toggleFilters(e) {
          let target = e.currentTarget;
          let $accordion = $(target).closest(".accordion");
          let $accordionContent = $accordion.find(".accordion__content");
          let isOpen = $accordionContent.hasClass("filter-open");
          $accordionContent.toggleClass("filter-open");
          $accordionContent.slideToggle("ease");
          $(target).toggleClass("devSvg");
        },
      },
    }).mount($filterSection);
  };
  document.addEventListener("DOMContentLoaded", () => {
    CollectionFilters();
    filters_inputs = document.querySelectorAll(".filters-wrap input");
    ProductsInfiniteLoad();
    if (!(window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD && localStorage.items_on_load) ) VueProductCards();
    initScrollToTop();
  });

  document.addEventListener("product-cards--loaded", () => {
    setTimeout(VueProductCards, 0);
  });
})();

const { createApp } = Vue;
let vms_products = [];
let VueProductCardsDann = () => {
  let $cards = Array.from(
    document.querySelectorAll(".card-wrapper:not(.v-initialized)")
  );
  vms_products = $cards.map(($card) => {
    let $productJsonData = $card.querySelector("[data-product-json]");
    let product = JSON.parse($productJsonData.value);
    let options_with_values = JSON.parse(
      $card.querySelector("[data-product-options-with-values-json]").value
    );
    product.options_with_values = options_with_values;
    // capture scroll top
    // $card.querySelectorAll("a").forEach(($a) => {
    //   $a.addEventListener("click", (e) => {
    //     sessionStorage.setItem(SESSION_KEY_SCROLLTOP, window.pageYOffset);
    //   });
    // });

    let vm_product;
    if (product) {
      vm_product = createApp({
        delimiters: ["${", "}"],
        data() {
          return { product };
        },
        mounted() {
          this.initImagesSwiper();
          $card.classList.add("v-initialized");
        },
        computed: {},
        methods: {
          initImagesSwiper() {
            let $images = $card.querySelector(".product-images-swiper");
            let initialSlide = window.innerWidth < 768 ? 0 : 1;
            new Swiper($images, {
              touchMove: true,
              speed: 250,
              loop: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: initialSlide,
              slidesPerView: "auto",
              touchStartPreventDefault: false,
              shortSwipes:true,
              threshold:10,
              pagination: {
                el: $card.querySelector(".swiper-pagination"),
                clickable: true,
              },
              navigation: {
                nextEl: $card.querySelector(".swiper-button-next"),
                prevEl: $card.querySelector(".swiper-button-prev"),
              },
            });
          },
          addItemToCart(e) {
            e.preventDefault();
            let $form = e.currentTarget.closest("form");
            let variant_id = $form.querySelector("input[name=id]").value;

            let variants = [
              {
                quantity: 1,
                id: variant_id,
              },
            ];
            if($form.querySelector('input[value="PRE-ORDER"]')){
              variants[0].properties={
                "":"PRE-ORDER"
              }
            }
            let items = {
              items: variants,
              sections: "cart-drawer",
            };

            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(items),
            })
              .then((res) => res.json())
              .then((parsedState) => {
                if (
                  parsedState.sections &&
                  parsedState.sections["cart-drawer"]
                ) {
                  let $cartDrawer = Shopify.theme.utils.stringToHTML(
                    parsedState.sections["cart-drawer"]
                  );
                  document.querySelector("#cart-drawer .cart-items").innerHTML =
                    $cartDrawer.querySelector(".cart-items").innerHTML;
                  document.dispatchEvent(new CustomEvent("product:added"));
                } else {
                  document.dispatchEvent(
                    new CustomEvent("cart:update", {
                      detail: { openDrawer: true },
                    })
                  );
                }
              })
              .catch(console.error);
          },
        },
      }).mount($card.querySelector(".card-quick-add"));
    }

    return vm_product;
  });
};
// let footer_height=document.querySelector('footer').offsetHeight + 180;
function ScrollExecute() {
  //   if (
  //   $(document).height() - footer_height  <
  //   $(document).scrollTop() + $(window).height()
  // ) {
    if (triggered == false) {
      let infini_interval= setInterval(f=>{
        if(infiniScroll_grid){
          let product_grid = document.querySelector("#product-grid");
          let infiniScroll_products =
          infiniScroll_grid.querySelectorAll(".grid__item");
          for (let i = 0; i < ppp; i++) {
          if (infiniScroll_products[i]) {
            infiniScroll_products[i].classList.add('shown')
            product_grid.insertAdjacentElement(
              "beforeend",
              infiniScroll_products[i]
            );
            triggered=false;
          } else {
            if (document.querySelector(".back-to-top"))
              document.querySelector(".back-to-top").style.display = "block";
            if (document.querySelector("#more"))
              document.querySelector("#more").style.display = "none";
            triggered = true;
            break;
          }
        }
        VueProductCardsDann();
        clearInterval(infini_interval);
      }
        else{
          console.log('waiting');
          triggered = true;
        }
      },10)
    }
  // }
}
const loaderObserver = new IntersectionObserver( entries => {
  entries.forEach(entry => {
    entry.isIntersecting?ScrollExecute():console.log('no scrollexec');
  })
})

if(document.getElementById("more"))loaderObserver.observe(document.getElementById("more"))

jQuery(document).ready(function () {
//   jQuery(window).scroll(function () {
//     setTimeout(ScrollExecute, 200);
//   });
  jQuery(document).on("click", ".devDisabled", function () {
    var ID = jQuery(this).attr("devVarinatId");
    console.log(ID);
    var varId = jQuery(".accordion__content .size-swatch input ").attr(
      "data-variant"
    );
    console.log(varId);
  });
});


function initializeButtonBehavior() {
  function handleResize() {
    const devIdColButtons = document.querySelectorAll("#devIdCol");

    if (window.innerWidth > 767) {
      devIdColButtons.forEach((button) => {
        button.disabled = true;
      });

      const targetNode = document.body;
      const observer = new MutationObserver(disableNewButtons);
      const config = { childList: true, subtree: true };
      observer.observe(targetNode, config);
    } else {
      devIdColButtons.forEach((button) => {
        button.disabled = false;
      });
    }
  }

  function disableNewButtons(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const newButtons = document.querySelectorAll("#devIdCol");
        newButtons.forEach((button) => {
          button.disabled = true;
        });
      }
    }
  }

  handleResize();
  window.addEventListener("resize", handleResize);
}

initializeButtonBehavior();
